import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "p-login-heading-3" }, "認証URLの有効期限が切れています", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-login-text-block" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "--is-align-left" }, "お手数ですが、ログインID・メールアドレス変更よりメールアドレスをご登録のうえ、新しい認証用メールをお受け取りください。"),
  /*#__PURE__*/_createElementVNode("p", { class: "--is-align-left" }, [
    /*#__PURE__*/_createTextVNode("ご不明な点がございましたら、下記までご連絡ください。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("a", { href: "https://survey.mynavi.jp/cre/?enq=jyLRMFjBeyo%3d" }, "お問い合わせフォーム")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "再設定する", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "認証URLの有効期限が切れています", -1)
const _hoisted_5 = [
  _hoisted_4
]

import { ref, watch } from 'vue';
import { RouterLink } from 'vue-router';
import MailSecurityPopupView from '../mailSecurity/MailSecurityPopupView.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MailSecurityExpiredPopupView',
  props: {
  showPopupByDefault: {
    type: Boolean,
    default: false
  },
  isCloseable: {
    type: Boolean,
    default: true
  }
},
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props



const isShowMailSecurityExpiredPopup = ref(false);


watch(() => props.showPopupByDefault, (val) => {
  isShowMailSecurityExpiredPopup.value = val;
}, { immediate: true });

const closeMailSecurityExpiredPopup = () => {
  isShowMailSecurityExpiredPopup.value = false;
  emit('close');
};

const openMailSecurityExpiredPopup = () => {
  isShowMailSecurityExpiredPopup.value = true;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isShowMailSecurityExpiredPopup.value)
      ? (_openBlock(), _createBlock(MailSecurityPopupView, {
          key: 0,
          isShowCloseBtnPopup: props.isCloseable,
          onClose: closeMailSecurityExpiredPopup
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2,
            _createVNode(_unref(RouterLink), {
              class: "p-recommend-button --type-2 --width-set-1 --has-icon t-decoration-none",
              to: { path: '/mail_security/form', query: { from: 'mail-security-expired' } }
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["isShowCloseBtnPopup"]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: "p-mail-security-modal-button js-modal-open-button",
      type: "button",
      onClick: openMailSecurityExpiredPopup
    }, _hoisted_5)
  ], 64))
}
}

})